import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
    
    list: [],
    selectedRole: {
        _id: undefined
    },
    roleAdded: false,
    roleUpdated: false,
    roleRemoved: false,
};

const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        getPermissions(state, action) {
            state.list = action.payload.permissions;
        },
        getPermissionById(state, action) {
            state.selectedRole = action.payload;
        },
        addPermissions(state, action) {
            state.roleAdded = true
        },
        updatePermissions(state, action) {
            state.roleAdded = true
        },
        removePermissions(state, action) {
            state.roleUpdated = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const permissionsActions = permissionsSlice.actions;
export default permissionsSlice;
